import React, { Component } from 'react'
import img from '../images/images (1).jfif'
export default class Portfoli extends Component {
  render() {
    return (
        <section className='portfolio'>
            <div className="kirishSoz">
                <h1>Portfolio</h1>
            </div>
            <ul>
                <li>
                    <img src={img} alt="" />
                    <a href="#">
                        watching
                    </a>
                    <p>online shoping website</p>
                </li>
                <li>
                    <img src={img} alt="" />
                    <a href="#">
                        watching
                    </a>
                    <p>online shoping website</p>
                </li>
                <li>
                    <img src={img} alt="" />
                    <a href="#">
                        watching
                    </a>
                    <p>online shoping website</p>
                </li>
                <li>
                    <img src={img} alt="" />
                    <a href="#">
                        watching
                    </a>
                    <p>online shoping website</p>
                </li>
                <li>
                    <img src={img} alt="" />
                    <a href="#">
                        watching
                    </a>
                    <p>online shoping website</p>
                </li>
                <li>
                    <img src={img} alt="" />
                    <a href="#">
                        watching
                    </a>
                    <p>online shoping website</p>
                </li>
            </ul>
        </section>
    )
  }
}
